module.exports = __webpack_public_path__ + "static/media/ello.f1833a5a.svg";